<template>
  <el-card style="margin-bottom: 20px">
    <!-- <div slot="header" class="clearfix">
      <span>个人中心</span>
    </div> -->

    <div class="user-profile">
      <div
        class="box-center"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <pan-thumb
          :image="`${fileUrl}/${user.avatar}`"
          :height="'100px'"
          :width="'100px'"
          :hoverable="false"
        >
          <div>Hello</div>
          {{ user.role }}
        </pan-thumb>
        <!-- <el-link target="_blank" style="padding-top: 10px;">选择头像</el-link> -->

        <el-upload
          class="avatar-uploader"
          action=""
          :http-request="handleUpload"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <el-link target="_blank">选择头像</el-link>
        </el-upload>
      </div>
      <div class="box-center">
        <div class="user-name text-center">{{ user.fullName }}</div>
        <div class="user-role text-center text-muted">
          <!-- {{ user.roleNames | uppercaseFirst }} -->
          {{ user.roleNames?.join(" | ") }}
        </div>
      </div>
    </div>

    <div class="user-bio">
      <!-- <div class="user-education user-bio-section">
        <div class="user-bio-section-header">
          <svg-icon icon-class="education" /><span>Education</span>
        </div>
        <div class="user-bio-section-body">
          <div class="text-muted">
            JS in Computer Science from the University of Technology
          </div>
        </div>
      </div> -->

      <div class="user-skills user-bio-section">
        <div class="user-bio-section-header">
          <!-- <svg-icon icon-class="skill" /><span>Skills</span> -->
        </div>
        <div
          class="user-bio-section-body"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <router-link :to="{ path: '/profile'}">
            <div class="progress-item" :class="{'item-active': $route.query?.tab === undefined}">
              <span>个人中心</span>
            </div>
          </router-link>
          <router-link :to="{ path: '/profile', query: { tab: 'course' } }">
            <div class="progress-item" :class="{'item-active': $route.query.tab === 'course'}">
              <span>我的课程</span>
            </div>
          </router-link>
          <router-link :to="{ path: '/profile', query: { tab: 'record' } }">
            <div class="progress-item" :class="{'item-active': $route.query.tab === 'record'}">
              <span>实训成绩</span>
            </div>
          </router-link>
          <!-- <div class="progress-item">
            <span>ESLint</span>
            <el-progress :percentage="100" status="success" />
          </div> -->
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { minioService } from "@/api/files";
import { usersService } from "@/api/users";

export default {
  components: { PanThumb },
  props: {
    activeTab: {
      type: String,
      default: () => {
        return "";
      },
    },
    user: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      imageUrl: undefined, // 头像路径
      fileUrl: process.env.VUE_APP_FILE_URL,
    };
  },
  methods: {
    // 头像上传请求
    handleUpload(data) {
      const formData = new FormData();
      formData.append("file", data.file);

      minioService
        .upload(formData, `boyuanclass/user/${this.user.id}`)
        .then((res) => {
          // 保存头像
          usersService.uploadAvatar(this.user.id, res.fileName).then(() => {
            this.user.avatar = res.fileName;
            // this.imageUrl = `${process.env.VUE_APP_FILE_URL}/${res.fileName}`
          });
        });
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      console.log(!isJPG, !isPNG, !isJPG || !isPNG);
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleActiveTab() {
      
    },
  },
};
</script>

<style lang="scss" scoped>
.box-center {
  margin: 0 auto;
  display: table;
}

.text-muted {
  color: #777;
}

.user-profile {
  .user-name {
    font-weight: bold;
  }

  .box-center {
    padding-top: 10px;
  }

  .user-role {
    padding-top: 10px;
    font-weight: 400;
    font-size: 14px;
  }

  .box-social {
    padding-top: 30px;

    .el-table {
      border-top: 1px solid #dfe6ec;
    }
  }

  .user-follow {
    padding-top: 20px;
  }
}

.user-bio {
  margin-top: 20px;
  color: #606266;

  span {
    padding-left: 4px;
  }

  .user-bio-section {
    font-size: 14px;
    padding: 15px 0;

    .user-bio-section-header {
      border-bottom: 1px solid #dfe6ec;
      padding-bottom: 10px;
      margin-bottom: 20px;
      font-weight: bold;
    }
  }

  .progress-item {
    padding: 10px 0;
    font-size: 14px;

    width: 150px;
    text-align: center;

    cursor: pointer;
  }

  .item-active {
    background-color: #ecf5ff;
    color: #66b1ff;
    font-weight: 600;
  }
}
</style>
